import $ from "jquery";

// MSH Tab Iframe print screen

$(".msh-buyer-tab_print").on("click", function(){
    var parent = $(this).parent();
    var iframe = $(parent).siblings(".responsive-embed").children("iframe");
    var iframeID = $(iframe).attr("id"); //find the element to print
    var myIframe = document.getElementById(iframeID).contentWindow;
    myIframe.focus();
    myIframe.print();
    return false;
});